module.exports = function(){
    
    var ua = navigator.userAgent.toLocaleLowerCase();

    if (ua.indexOf("ipad") > -1) {
        return 1;
    }


};